import React from 'react';

type StatusState = 'online' | 'connecting' | 'offline' | 'fault';

interface StatusDotProps {
  state: StatusState;
  label?: string;
  style?: React.CSSProperties;
}

const StatusDot: React.FC<StatusDotProps> = ({ state, label, style }) => (
  <span className={`status status--${state}`} style={style}>
    <span className="status__dot" />
    {label && <span>{label}</span>}
  </span>
);

export default StatusDot;
